
export enum SearchScopeType {
    CHAT = 'chat',
    SCHEDULE_USERS = 'schedule_users',
    COMPANIES = 'companies',
    GENERIC = 'generic',
    NETWORK = 'network',
    LOG = 'log'
};
